import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Helmet } from '@/common/components/Helmet'
import Survey from '@/features/surveys/components/Survey'
import { useSurveyPreview } from '../-context'
import { isValidLanguageId, languageObject } from '@/common/classes/LanguageUtils'
import { titleTagSuffix } from '@/common/constants'
import { Store } from '@/store/Store'

export const Route = createFileRoute(
  '/app/survey-previews/$surveyId/$languageId/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { surveyId, languageId } = Route.useParams()
  const { survey, demographicOptions } = useSurveyPreview()

  const [effectiveLanguageId, setEffectiveLanguageId] = useState<string | null>(
    null,
  )

  const languages = useSelector((state: Store) => state.app_meta.data.languages)

  // Set effectiveLanguageId
  useEffect(() => {
    let newELID = null
    if (isValidLanguageId(languages, languageId)) {
      let langObj = languageObject(languages, languageId)
      if (langObj) {
        newELID = langObj.id!
      }
    }
    setEffectiveLanguageId(newELID)
  }, [languageId, languages])

  // Handle missing data
  if (!effectiveLanguageId) {
    return null
  }

  return (
    <>
      <Helmet>
        <title>
          Preview: {survey.name_en}
          {titleTagSuffix}
        </title>
        <meta property="og:title" content={`Preview: ${survey.name_en}`} />
        <meta
          property="og:url"
          content={`https://${import.meta.env.VITE_LOCAL_HOSTNAME}/app/survey-previews/${Number(surveyId)}/${effectiveLanguageId}`}
        />
      </Helmet>

      <Survey
        demographicOptions={demographicOptions}
        languageId={effectiveLanguageId}
        readOnly={true}
        survey={survey}
      />
    </>
  )
}
